import { EBanners } from '../../../constants/banners';
import { type IMapBannersProps } from '../../../types/props';

import { useRealtorReportBanner } from './useRealtorReportBanner';

export function useGetCurrentBanner(params: IMapBannersProps): EBanners | null {
  const realtorReportBannerType = useRealtorReportBanner(params);

  const leadsBannerType = !params.userIsAgent && EBanners.Leads;

  return realtorReportBannerType || leadsBannerType || null;
}
